import { IAvailabilityTemplateForm } from 'components/AvailabilityTemplateModalForm/UpperModal';
import { IClinic } from 'model/v2/clinic';
import { Moment } from 'moment';
import { setShiftData } from 'model/v2/setShiftBlock';

export interface DayAvailability {
  startTime: Moment;
  length: number;
}

export interface ProviderDailyMaxHours {
  dayOfWeek: number;
  value: number;
}
export interface ModalData extends IAvailabilityTemplateForm {
  Day: DayAvailability[];
  clinics: IClinic[];
  providerDefaultClinicsIds: number[];
  dailyMaxHours?: ProviderDailyMaxHours[];
  employment?: string;
  getShiftDropdownOptions?: setShiftData[];
}

export interface CalenderEvent {
  id?: number;
  title: string;
  type?: string;
  location: number;
  isAdmin?: boolean;
  start: Date;
  end: Date;
  isInClinic?: boolean;
  isOffsite?: boolean;
  isTelehealth?: boolean;
  clinics?: IClinic[];
  isAdditionalShift?: boolean;
  block?: string;
  schedulingShiftId?: number;
}

export interface ClientAvailabilityEvent {
  id?: number;
  title: string;
  start: Date;
  end: Date;
  location: number;
  blockId?: number;
}
export interface ClientBlockAvailabilityEvent {
  id?: number;
  blocks: string[];
  location: number;
}
export interface SchedulingBlock {
  id: number;
  days: number[];
  startTime: string;
  endTime: string;
}
export interface SchedulingBlockOption {
  label: string;
  value: string;
}
export type AvailabilityEvent = CalenderEvent | ClientAvailabilityEvent;

export interface AvailabilityTemplateData {
  id?: number;
  department: string;
  speciality: { id: number };
  specialityAbr?: string;
  name: string;
  createdBy: string;
  isActive: boolean;
  default: boolean;
  dayAvailabilities: AvailabilityTemplateEvents[];
}
export interface AvailabilityTemplateEvents {
  id?: number;
  dayOfWeek: number;
  startTime: string;
  endTime: string;
  type?: string;
  isAdmin: boolean;
  location?: number;
  isInClinic?: boolean;
  isOffsite?: boolean;
  isTelehealth?: boolean;
  clinics?: IClinic[];
  schedulingShiftId?: number;
  isAdditionalShift?: boolean;
  blockId?: number;
}

export interface AvailabilityTemplateEventsInput
  extends AvailabilityTemplateEvents {
  locationInput?: number;
}
export interface AlternateAvailabilityTemplate {
  id: number;
  name: string;
  description: string | null;
  isDefault: boolean;
  activeFrom: Date;
  activeTo: Date;
  frequency: string | null;
}

export interface DayAvailabilityBlock {
  dayOfWeek: number;
  startTime: string;
  endTime: string;
  opensOn?: string;
}

export interface TimeOverlapMap {
  [key: string]: number[];
}

export interface DayTimeOverlap {
  startTime: string;
  endTime: string;
  days: string;
}

export const daysMap: Record<string, string> = {
  '1': 'M',
  '2': 'T',
  '3': 'W',
  '4': 'R',
  '5': 'F',
  '6': 'S'
};
